import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SmsTerms from './pages/SmsTerms';
import BusinessVerification from './pages/BusinessVerification';
import Compliance from './pages/Compliance';
import OptOut from './pages/OptOut';
import Support from './pages/Support';
import AuthorizedRep from './pages/AuthorizedRep';
import SmsMarketing from './pages/services/SmsMarketing';
import EmailMarketing from './pages/services/EmailMarketing';
import MarketingAutomation from './pages/services/MarketingAutomation';
import CampaignManagement from './pages/services/CampaignManagement';
import HowItWorks from './pages/HowItWorks';
import PlatformRequirements from './pages/PlatformRequirements';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/sms-marketing" element={<SmsMarketing />} />
              <Route path="/services/email-marketing" element={<EmailMarketing />} />
              <Route path="/services/marketing-automation" element={<MarketingAutomation />} />
              <Route path="/services/campaign-management" element={<CampaignManagement />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/sms-terms" element={<SmsTerms />} />
              <Route path="/verification" element={<BusinessVerification />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/opt-out" element={<OptOut />} />
              <Route path="/support" element={<Support />} />
              <Route path="/authorized-rep" element={<AuthorizedRep />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/platform-requirements" element={<PlatformRequirements />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
